// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GrUR","left":"styles_left__2aJqt","desktopActions":"styles_desktopActions__2lfvo","title":"styles_title__1Mj_P"};